"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Input = require("./Input");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node.isRequired
} : {};
const defaultProps = {};

const Select = ({
  children,
  ...otherProps
}) => {
  return (0, _core.jsx)(_Input.Input, (0, _extends2.default)({
    inputComponent: "select"
  }, otherProps, {
    select: true
  }), children);
};

exports.Select = Select;
process.env.NODE_ENV !== "production" ? Select.propTypes = propTypes : void 0;
Select.defaultProps = defaultProps;